import type { RouteObject } from 'react-router';
import { LoginPage } from './pages/LoginPage';

/** The sign-in screen, which renders outside the office shell; the router adds its full-screen error page. */
export const LOGIN_ROUTE: RouteObject = { path: '/login', element: <LoginPage /> };
